export function getChatURL(urlParams = {}): string {
  let url = `${window.location.protocol}//${window.location.host}/chat/?test_user=1`;

  Object.entries(urlParams).forEach((urlParam) => {
    const key = urlParam[0];
    const val = urlParam[1];
    url += `&${key}=${val}`;
  });

  return url;
}

export function getChatWindowTitle(handle: string): string {
  return `Chat with ${handle}`;
}

export function openChatInNewWindow(urlParams = {}): void {
  const url = getChatURL(urlParams);
  const chatWindow = window.open(
    url,
    "_blank",
    "location=0,height=567,width=320,scrollbars=yes,status=no"
  );
  chatWindow.focus();
}

export function getTestBotHandle(): string {
  const urlParts = window.location.host.split(".");

  return urlParts[0];
}

/**
 * Examines the URL to get the correct domain to specify for Embed
 * e.g. "ada", "ada-dev", "ada-stage"
 * localhost returns the default
 */
export function getTestBotDomain(): string {
  const urlParts = window.location.host.split(".");

  if (urlParts.length === 3) {
    return urlParts[1];
  }

  return "ada";
}

/**
 * Examines the URL to get the correct cluster to specify for Embed
 * e.g. "ca", "att", "" (if empty, Embed defaults to the US cluster)
 * localhost returns the default
 *
 * @returns {String}
 */
export function getTestBotCluster(): string {
  const urlParts = window.location.host.split(".");

  if (urlParts.length === 4) {
    return urlParts[1];
  }

  return ""; // defaults to US cluster
}
